import { Controller } from '@hotwired/stimulus';

// Highlights the active bullet matching the card currently in view inside the
// horizontally scrollable list of pending actions (mobile only).
export default class PendingActionsCarouselController extends Controller {
  static targets = ['scroll', 'dot'];

  connect() {
    if (!this.hasScrollTarget || this.dotTargets.length === 0) return;

    this.#observeCards();
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  #observeCards() {
    this.cards = Array.from(this.scrollTarget.children);
    this.observer = new IntersectionObserver(
      (entries) => this.#updateActiveDot(entries),
      { root: this.scrollTarget, threshold: 0.6 }
    );
    this.cards.forEach((card) => this.observer.observe(card));
  }

  #updateActiveDot(entries) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      const activeIndex = this.cards.indexOf(entry.target);
      this.dotTargets.forEach((dot, dotIndex) => {
        dot.classList.toggle('active', dotIndex === activeIndex);
      });
    });
  }
}
